import React from "react";
import { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import moment from "moment"; // Getting day from date and modifying date format
import { Calendar } from "react-multi-date-picker";
import Modal from "@mui/material/Modal";
import InputLabel from "@mui/material/InputLabel";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const TimePreference = () => {
  // ADD TIME MODAL
  // ------- Edit Slot ---------------
  const [isItEditing, setIsItEditing] = useState(false); // "isItEditing" keeps track of whether we are editing the already entered schedule for both generic and exception schedule
  const [oldTimeWhileEditingASlot, setOldTimeWhileEditingASlot] = useState({
    // Data that will be prefilled while editing any slot for
    hrs: "12",
    min: "00",
    merd: "AM",
    start: 0,
    end: 0,
    slots: 0,
  });
  const [
    disableDaysWhileEditingGenericSlot,
    setDisableDaysWhileEditingGenericSlot,
  ] = useState({
    // To disable days that cannot be edit because they don't follow the edit rules
    mon: false,
    tue: false,
    wed: false,
    thu: false,
    fri: false,
    sat: false,
    sun: false,
  });
  // ---- Model Settings for Generi Schedule Popup ----
  const [openGenericSchedulePopup, setOpenGenericSchedulePopup] =
    useState(false);
  const [checkedDaysGenericSchedule, setCheckedDaysGenericSchedule] = useState({
    // Store checked days while adding generic schedule
    mon: false,
    tue: false,
    wed: false,
    thu: false,
    fri: false,
    sat: false,
    sun: false,
  });
  const [allDaysCheckedGenericSchedule, setAllDaysCheckedGenericSchedule] =
    useState(false); // To check and uncheck Select All
  useEffect(() => {
    // Handle Select All
    checkedDaysGenericSchedule.mon === true &&
    checkedDaysGenericSchedule.tue === true &&
    checkedDaysGenericSchedule.wed === true &&
    checkedDaysGenericSchedule.thu === true &&
    checkedDaysGenericSchedule.fri === true &&
    checkedDaysGenericSchedule.sat === true &&
    checkedDaysGenericSchedule.sun === true
      ? setAllDaysCheckedGenericSchedule(true)
      : setAllDaysCheckedGenericSchedule(false);
  }, [checkedDaysGenericSchedule]);
  const [time, setTime] = useState({
    // Stores the from time datas from popup
    hrs: "12",
    min: "00",
    merd: "AM",
  });
  const [slots, setSlots] = useState(0); // No of slot that are selected through popup
  const handleSlotsChange = (event) => {
    // Handling slot change event
    setSlots(event.target.value);
  };
  const handleOpenGenericSchedulePopup = () => {
    setOpenGenericSchedulePopup(true);
  };
  const handleCloseGenericSchedulePopup = () => {
    setOpenGenericSchedulePopup(false);
    setIsItEditing(false);
    setDisableDaysWhileEditingGenericSlot({
      mon: false,
      tue: false,
      wed: false,
      thu: false,
      fri: false,
      sat: false,
      sun: false,
    });
    setCheckedDaysGenericSchedule({
      ...checkedDaysGenericSchedule,
      mon: false,
      tue: false,
      wed: false,
      thu: false,
      fri: false,
      sat: false,
      sun: false,
    });
    setAllDaysCheckedGenericSchedule(false);
    setTime({
      hrs: "12",
      min: "00",
      merd: "AM",
    });
    setSlots(0);
  };

  // --- Handling Popup for "Clear All" Button while entering generic schedule ---
  const [openClearGenericSchedulePopup, setOpenClearGenericSchedulePopup] =
    useState(false);
  const handleClearGenericSchedulePopupOpen = () => {
    setOpenClearGenericSchedulePopup(true);
  };
  const handleClearGenericSchedulePopupClose = () => {
    setOpenClearGenericSchedulePopup(false);
  };
  // ---------- END -------------

  // "ADD TIME PREFERENCE"
  // ----- Final Generic and Exception Array for Backend -----
  /* E.g. {
        mon: [[1.25, 1.75], [9.5, 12.75], [15, 17.25]], Time is in 24 hour decimal format
        tue: [],
        wed: [],
        thu: [],
        fri: [],
        sat: [],
        sun: [],
       } */
  const [finalGenericSchdArray, setFinalGenericSchdArray] = useState([]);
  // const [expArray, setExpArray] = useState([]); // For sending exception dates list to backend
  useEffect(() => {
    console.log("generic: ", finalGenericSchdArray);
  }, [finalGenericSchdArray]);
  // --------------------------------------------------------

  // ------------ Initializing Days Array -------------------
  // Generic Array
  /* {
    mon:[{init: [0, 1], final: ['12:00 AM', '12:30 AM]}, {init: [2, 3], final: ['01:00 AM', '01:30 AM]}]
    tue: [],
    wed: [],
    thu: [],
    fri: [],
    sat: [],
    sun: [],
  }*/
  // These arrays will contain object that has readable time format and their specific location
  const [slotwiseGenericSchd, setSlotwiseGenericSchd] = useState({
    mon: [],
    tue: [],
    wed: [],
    thu: [],
    fri: [],
    sat: [],
    sun: [],
  });
  const [boolGnrcSchd, setBoolGnrcSchd] = useState({
    // These arrays will contain 48 boolean item that represents the status of any perticular
    // mon: [false * 48]
    mon: [],
    tue: [],
    wed: [],
    thu: [],
    fri: [],
    sat: [],
    sun: [],
  });
  // Exceptional Array
  /*  
    - "selectedDateBoolArr" store boolean array for currently selected date in calender
      e.g. [false * 48]
    - "selectedDateSlotsArr" stores slots array for currently selected date in calender
      init: [startSlotID, endSlotId], final: [startTime, endTime]
      [{init: [0, 1], final: ['12:00 AM', '12:30 AM]}, {init: [2, 3], final: ['01:00 AM', '01:30 AM]}]
    - "excpDatesBoolArr" stores (custom dates and their respective schedule) and (exception dates) in boolean format
      e.g. [{date: "31-09-2022", slots: [false * 3, true * 5, false * 40]}, {date: "31-09-2022", slots: [false * 48]}]
    - "excpDatesSlotsArr" stores custom dates and their respective slots in both slotId and Time format and holiday dates
      e.g. [{date: "31-09-2022", slots: [{init: [0, 2], final: [12:00 AM, 01:30 AM]}, {init: [33, 36], final: [04:30 PM, 6:00 PM]}]}, {date: "31-09-2022", slots: [empty]}]
    - ""
  */
  const [selectedDateBoolArr, setSelectedDateBoolArr] = useState([]);
  const [selectedDateSlotsArr, setSelectedDateSlotsArr] = useState([]);
  const [excpDatesBoolArr, setExcpDatesBoolArr] = useState([]);
  const [excpDatesSlotsArr, setExcpDatesSlotsArr] = useState([]);
  // Hooks
  useEffect(() => {
    console.log("boolGnrcSchd: ", boolGnrcSchd);
  }, [boolGnrcSchd]);
  useEffect(() => {
    // console.log("days: ", slotwiseGenericSchd);
  }, [slotwiseGenericSchd]);
  // ---------------------------------------------------------
  // Assigning boolean(initially false) array of 48 item to boolGnrcSchd(object that contain slot status of all days in boolean)
  const initGnrcSchdBool = () => {
    let mon = new Array(48);
    let tue = new Array(48);
    let wed = new Array(48);
    let thu = new Array(48);
    let fri = new Array(48);
    let sat = new Array(48);
    let sun = new Array(48);
    for (let i = 0; i < 48; i++) {
      mon[i] = false;
      tue[i] = false;
      wed[i] = false;
      thu[i] = false;
      fri[i] = false;
      sat[i] = false;
      sun[i] = false;
    }
    setBoolGnrcSchd({ ...boolGnrcSchd, mon, tue, wed, thu, fri, sat, sun });
  };
  useEffect(() => {
    initGnrcSchdBool();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // ----------------------------------------------------------------

  /* 
    Converting Slots form Boolean array to Readable 12hours Time format(also slotId format)
    [false, true, true, false * 43, true, true] ->
    [{init: [1, 2], final: ["12:30 AM", "01:00 AM"]}, {init: [47, 48], final: ["11:30 PM", "11:59 PM"]}] 
  */
  const convrtBoolTo12HTime = (dayBoolArr) => {
    // Filtering out slot index which is true e.g. [ 1, 2, 4, 5, 6, 10, 12]
    let copyDayBoolArr = [];
    dayBoolArr.forEach((item, index) => {
      if (item === true) {
        copyDayBoolArr.push(index);
      }
    });

    // Creating the Start and End Point of slotIds e.g. [[1,2], [4, 6], [10], [12]] and storing it in "daySlots"
    let daySlots = [];
    daySlots = copyDayBoolArr.reduce((r, n) => {
      const lastSubArray = r[r.length - 1];
      if (!lastSubArray || lastSubArray[lastSubArray.length - 1] !== n - 1) {
        r.push([]);
      }
      r[r.length - 1].push(n);
      return r;
    }, []);

    // Creating Meaningfull 12-H Time Slots from slotIds [1, 2] -> ["12:30 AM", "01:00 AM"] and storing it in "t12HSlotsArr"
    let t12HSlotsArr = [];
    daySlots.forEach((item) => {
      let start = 0;
      let end = 0;
      // Start
      start = moment(
        Math.floor(item[0] / 2) + (item[0] % 2 === 0 ? ":00" : ":30"),
        "H:mm"
      ).format("hh:mm A");
      if (item.length !== 1) {
        // End
        end =
          item[item.length - 1] === 47
            ? "23:59"
            : Math.floor((item[item.length - 1] + 1) / 2) +
              ((item[item.length - 1] + 1) % 2 === 0 ? ":00" : ":30");
        end = moment(end, "H:mm").format("hh:mm A");
        t12HSlotsArr.push({
          init: [item[0], item[item.length - 1]],
          final: [start, end],
        });
      } else {
        // End
        end =
          item[0] === 47
            ? "11:59 PM"
            : moment(
                Math.floor((item[0] + 1) / 2) +
                  ((item[0] + 1) % 2 === 0 ? ":00" : ":30"),
                "H:mm"
              ).format("hh:mm A");
        t12HSlotsArr.push({
          init: [item[0], item[0]],
          final: [start, end],
        });
      }
    });
    return t12HSlotsArr;
  };
  // -------------------------------------------------------------------------

  useEffect(() => {
    // console.log("convrtBoolTo12HTime");
  }, [boolGnrcSchd]);

  /* 
    - "calculateNOSlots" takes hours, minutes and meridiem and calculates the no of slots
  */
  const calculateNoSlots = (hours, minutes, merd) => {
    let noOfSlots = hours * 2; // slotId ranges from 0 to 47 as there are 48 slot in a day and it will be according to "from time"
    if (merd === "AM") {
      if (hours === "12") {
        noOfSlots = 0;
      }
    } else {
      noOfSlots += 24;
      if (hours === "12") {
        noOfSlots = 24;
      }
    }
    minutes === "00" ? (noOfSlots += 0) : (noOfSlots += 1);
    return noOfSlots;
  };

  /* 
    - Add (and Combine them if required) additional time slots to existing boolean Array(set Slots to true)(modifies existing Array)
      concatSlots(dayArray, hours, minutes, merd, slot) => {return BooleanArray}
      e.g. (daysBoolArray[mon], 12, 30, AM, 4) -> [false, true * 4, false * 43]
    - Takes boolean array of slots for a given day, starting time of a session in 12 hour format and no of slots and returns final boolean 
      array of total no of slots
  */
  const concatSlots = (day, hours, minutes, merd, slot) => {
    // Calculating slot no
    // console.log(day, hours, minutes, merd, slot)
    let slotId = calculateNoSlots(hours, minutes, merd);
    // Adding Slots in Day Array
    let getArr = [...day];
    if (slotId + slot > 48) {
      for (let j = slotId; j < 48; j++) {
        getArr[j] = true;
      }
    } else {
      for (let j = slotId; j < slotId + slot; j++) {
        getArr[j] = true;
      }
    }
    return getArr;
  };
  // ---------------------------------------------
  /* 
    - Creating or Updating Days Boolean Array(boolGnrcSchd) for generic schedule
      syntax: addNewGenericTimeSlots(selectedHours, selectedMinutes, selectedMeridiem, selectedSlot, selectedDay) 
      addNewGenericTimeSlots(hours, minutes, merd, slot, selectedDays) =>{setBoolGnrcSchd(
        mon: boolGnrcSchd.mon,
        tue: boolGnrcSchd.tue,
        wed: boolGnrcSchd.wed,
        thu: boolGnrcSchd.thu,
        fri: boolGnrcSchd.fri,
        sat: boolGnrcSchd.sat,
        sun: boolGnrcSchd.sun,
      )}
    - It will add/update new slots to the existing generic schedule and if their is no modification in any of the day then it will remain the 
      same
  */
  const addNewGenericTimeSlots = (hours, minutes, merd, slot, selectedDays) => {
    console.log(hours, minutes, merd, slot, selectedDays);
    let copyBoolGnrcSchd = {
      // Making copy of original Days Boolean Array(boolGnrcSchd)
      mon: [...boolGnrcSchd.mon],
      tue: [...boolGnrcSchd.tue],
      wed: [...boolGnrcSchd.wed],
      thu: [...boolGnrcSchd.thu],
      fri: [...boolGnrcSchd.fri],
      sat: [...boolGnrcSchd.sat],
      sun: [...boolGnrcSchd.sun],
    };
    // Converting from time to Slots No
    let slotId = calculateNoSlots(hours, minutes, merd);
    let m_DayIndex = 0;
    for (let aDay in copyBoolGnrcSchd) {
      if (selectedDays[aDay]) {
        // Creating or Updating a Day Boolean Array
        copyBoolGnrcSchd[aDay] = concatSlots(
          boolGnrcSchd[aDay],
          hours,
          minutes,
          merd,
          slot
        );
        if (slotId + slot > 48) {
          // If Slots are exceeding current limit then the remaining will get added to next day
          console.log(slotId + slot - 48);
          let nextDay = m_DayIndex < 6 ? m_DayIndex + 1 : 0;
          copyBoolGnrcSchd[Object.keys(boolGnrcSchd)[nextDay]] = concatSlots(
            boolGnrcSchd[Object.keys(boolGnrcSchd)[nextDay]],
            "12",
            "00",
            "AM",
            slotId + slot - 48
          );
        }
      }
      m_DayIndex++;
    }
    setBoolGnrcSchd(copyBoolGnrcSchd);
  };
  // ---------------------------------------------------------------

  // Creating or Updating Days Array(slotwiseGenericSchd)
  useEffect(() => {
    let days = {
      mon: [...slotwiseGenericSchd.mon],
      tue: [...slotwiseGenericSchd.tue],
      wed: [...slotwiseGenericSchd.wed],
      thu: [...slotwiseGenericSchd.thu],
      fri: [...slotwiseGenericSchd.fri],
      sat: [...slotwiseGenericSchd.sat],
      sun: [...slotwiseGenericSchd.sun],
    };
    for (let day in days) {
      days[day] = convrtBoolTo12HTime(boolGnrcSchd[day]);
    }
    setSlotwiseGenericSchd(days);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [boolGnrcSchd]);
  // -----------------------------------------

  /* 
    - DisabledDaysWhileEditing: It keeps tracks of the days which can not be edited while modifying a given day
      It will disable the days checkbox which cannot be edited and used in the generic schedule popup
      disabledDaysWhileEditing(from time, to time) => {setDisplay(checked_Array)} 
  */
  const disabledDaysWhileEditing = (start, end) => {
    let checked = {
      mon: true,
      tue: true,
      wed: true,
      thu: true,
      fri: true,
      sat: true,
      sun: true,
    };
    for (let day in slotwiseGenericSchd) {
      slotwiseGenericSchd[day]?.forEach((item) => {
        if (item.init[0] === start && item.init[1] === end) {
          checked[day] = false;
        }
      });
    }
    setDisableDaysWhileEditingGenericSlot(checked);
  };
  // ------------------------------------------------------------------

  /* 
    - Editing Slots in Generic Schedule: Adding, editing and removing the slots in generic schedule
      editGenericTimeSlots = (selectedDays, start, end, hours, minutes) => {return setBoolGnrcSchd(Days_Array)} 
    - It takes list of days starting time, and no of slots and adds these details in the boolean array which automatically get reflected in 
      generic slot array by useEffect hook
  */
  const editGenericTimeSlots = (
    selectedDays,
    start,
    end,
    hours,
    minutes,
    merd,
    slot
  ) => {
    let copyBoolGnrcSchd = {
      mon: [...boolGnrcSchd.mon],
      tue: [...boolGnrcSchd.tue],
      wed: [...boolGnrcSchd.wed],
      thu: [...boolGnrcSchd.thu],
      fri: [...boolGnrcSchd.fri],
      sat: [...boolGnrcSchd.sat],
      sun: [...boolGnrcSchd.sun],
    };
    for (let aDay in selectedDays) {
      if (selectedDays[aDay]) {
        for (let a = start; a <= end; a++) {
          copyBoolGnrcSchd[aDay][a] = false;
        }
        console.log("edited custom schedule... ", copyBoolGnrcSchd[aDay]);
        // Calculating slot no
        let slotId = calculateNoSlots(hours, minutes, merd);
        let m_DayIndex = 0;
        for (let anoElem in copyBoolGnrcSchd) {
          if (selectedDays[anoElem]) {
            // Updating a Day Boolean Array
            copyBoolGnrcSchd[anoElem] = concatSlots(
              copyBoolGnrcSchd[anoElem],
              hours,
              minutes,
              merd,
              slot
            );
            console.log(hours, minutes, merd, slot);
            // If Slots are exceeding current limit then it will get added to next day
            let nextDay = m_DayIndex < 6 ? m_DayIndex + 1 : 0;
            copyBoolGnrcSchd[Object.keys(copyBoolGnrcSchd)[nextDay]] =
              concatSlots(
                copyBoolGnrcSchd[Object.keys(copyBoolGnrcSchd)[nextDay]],
                "12",
                "00",
                "AM",
                slotId + slot - 48
              );
          }
          m_DayIndex++;
        }
      }
    }
    setBoolGnrcSchd(copyBoolGnrcSchd);
  };
  // ------------------------------------------------------

  /* 
    - Deleting a Slot in Generic Schedule: It'll delete a particular slot of any day in generic schedule
      syntax: deleteSlots(selectedDayArr, startSlotId, endSlotId) => {setBoolGnrcSchd({ ...boolGnrcSchd, [day]: dys })}
      Takes a day name, startSlotId and endSlotId as argument and removes that specified slot/slots(in the chip) from the boolean generic schedule array
      selectedDay - (mon/tue/wed/thu/fri/sat/sun)
  */
  const deleteSlots = (selectedDay, startSlotId, endSlotId) => {
    let selectedDayBoolArr = [...boolGnrcSchd[selectedDay]];
    for (let a = startSlotId; a <= endSlotId; a++) {
      selectedDayBoolArr[a] = false;
    }
    setBoolGnrcSchd({ ...boolGnrcSchd, [selectedDay]: selectedDayBoolArr });
  };
  // ---------------------------------------
  // END

  // EDIT AVAILABILITY AND ADD EXCEPTION / CUSTOM SCHEDULE
  // -------------- Model --------------
  const [calenderDate, setCalenderDate] = useState(new Date()); // "calenderDate" stores the date selected in the calender.
  const [isCustomEditPopupOpen, setIsCustomEditPopupOpen] = useState(false); // "isCustomEditPopupOpen" is a boolean value that shows whether "Edit Availability" popup is open or closed
  const handleIsCustomEditPopupOpen = () => {
    getCustomOrGnrcSchd(calenderDate);
    setIsCustomEditPopupOpen(true);
  };
  const handleIsCustomEditPopupClose = () => {
    setIsCustomEditPopupOpen(false);
  };
  const [dayIndex, setDayIndex] = useState(0); // Index of the perticular day
  useEffect(() => {
    if (calenderDate.getDay() === 0) {
      setDayIndex(6);
    } else {
      setDayIndex(calenderDate.getDay() - 1);
    }
    console.log(excpDatesBoolArr);
    // console.log(calenderDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calenderDate]);
  // ----------------------------

  // ------- 48 item array -------
  let dayBoolArray = new Array(48);
  for (let i = 0; i < 48; i++) {
    dayBoolArray[i] = false;
  }
  useEffect(() => {
    // Assigning 48 item boolean array to current boolean array
    setSelectedDateBoolArr(dayBoolArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // ----------------------------

  /* 
    - Converting Current Boolean Array (selectedDateBoolArr) to Readable Array(selectedDateSlotsArr)
    - Update "excpDatesSlotsArr" whenever "excepDatesBoolArr" is changed
  */
  useEffect(() => {
    // If there is change in excpDatesBoolArr then this will run
    let arrayBool = [];
    excpDatesBoolArr.forEach((obj) => {
      let result = convrtBoolTo12HTime(obj.slots);
      arrayBool.push({ date: obj.date, slots: result });
    });
    console.log("excpDatesBoolArr: ", excpDatesBoolArr);
    setExcpDatesSlotsArr(arrayBool);
  }, [excpDatesBoolArr]);

  // -----------
  useEffect(() => {
    console.log("excpDatesSlotsArr: ", excpDatesSlotsArr);
  }, [excpDatesSlotsArr]);
  // -------------------------------

  /* 
    - If there is any change in "selectedDateBoolArr" then it'll update the current 12-H Time and slotId format array(selectedDateSlotsArr)
  */
  useEffect(() => {
    // console.log("changed");
    console.log("selectedDateBoolArr: ", selectedDateBoolArr);
    let result = convrtBoolTo12HTime(selectedDateBoolArr);
    // console.log("result: ", result);
    setSelectedDateSlotsArr(result);
  }, [selectedDateBoolArr]);
  // -------------------------------

  /* 
    - Getting custom/generic schedule for the Current Boolean Array(selectedDateBoolArr) and Current 12-H Time Slots(selectedDateSlotsArr)
      for the selected date in calender
      syntax: getCustomOrGnrcSchd(currentlySelectedDateInCalender)
  */
  const getCustomOrGnrcSchd = (m_selectedDate) => {
    const currentDate = moment(m_selectedDate).format("DD/MM/YYYY");
    const currentDay = moment(m_selectedDate).format("ddd").toLowerCase();
    let check = false;
    excpDatesBoolArr?.forEach((item) => {
      if (item.date === currentDate) {
        // console.log("reached here 1");
        // console.log(item.slots);
        setSelectedDateBoolArr([...item.slots]);
        check = true;
      }
    });
    if (!check) {
      setSelectedDateBoolArr([...boolGnrcSchd[currentDay]]); // Call by Value
      // setSelectedDateSlotsArr([...slotwiseGenericSchd[currentDay]]);
    }
  };
  useEffect(() => {
    // updating current boolean array(selectedDateBoolArr) and readable array(selectedDateSlotsArr)
    getCustomOrGnrcSchd(calenderDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calenderDate]);
  // --------------------------------
  // useEffect(() => {
  //   getCustomOrGnrcSchd(calenderDate);
  //   // console.log("excpDatesBoolArr changed");
  // }, [excpDatesBoolArr]);
  useEffect(() => {
    // Logging current array
    console.log("selectedDateSlotsArr: ", selectedDateSlotsArr);
    console.log("selectedDateBoolArr: ", selectedDateBoolArr);
  }, [selectedDateSlotsArr]);

  // "resetToGenrcSchd" will reset the selected date schedule to generic day schedule
  const resetToGenrcSchd = (m_selectedDate) => {
    const currentDate = moment(m_selectedDate).format("DD/MM/YYYY");
    const currentDay = moment(m_selectedDate).format("ddd").toLowerCase();
    let copyExcpDatesBoolArr = [...excpDatesBoolArr];
    copyExcpDatesBoolArr?.forEach((item, index) => {
      if (item.date === currentDate) {
        copyExcpDatesBoolArr.splice(index, 1); // Removing this exception
      }
    });
    console.log("copyExcpDatesBoolArr", copyExcpDatesBoolArr);
    setExcpDatesBoolArr(copyExcpDatesBoolArr);
    setSelectedDateBoolArr([...boolGnrcSchd[currentDay]]);
    // setSelectedDateSlotsArr(slotwiseGenericSchd[currentDay]);
  };
  // ------------------

  /* 
    - excpCheck
  */
  const checkArrayEquality = (firstArray, secondArray) => {
    // All array will be having length 48
    if (firstArray.length !== 48 || secondArray.length !== 48) {
      return false;
    }
    let index = 0;
    while (index < 48) {
      if (firstArray[index] !== secondArray[index]) {
        return false;
      }
      index++;
    }
    return true;
  };

  /*   
    - Add Slots in Edit Availability : This will add new slot to excpDatesSlotsArr list
      syntax: addNewCustomSlot(selectedDate, SelectedHours, SelectedMinutes, SelectedMeridiem, SelectedSlots)
  */
  const addNewCustomSlot = (m_selectedDate, hours, minutes, merd, numSlots) => {
    const currentDate = moment(m_selectedDate).format("DD/MM/YYYY");
    let copyExcpDatesBoolArr = [...excpDatesBoolArr];
    let result = concatSlots(
      selectedDateBoolArr,
      hours,
      minutes,
      merd,
      numSlots
    );
    /*  
    Checking if new custom schedule and generic schedule are same or not and if they are then we will remove this date from exception list and return
     */
    if (
      checkArrayEquality(
        result,
        boolGnrcSchd[moment(m_selectedDate).format("ddd").toLowerCase()]
      )
    ) {
      copyExcpDatesBoolArr?.forEach((item, index) => {
        if (item.date === currentDate) {
          copyExcpDatesBoolArr.splice(index, 1); // Removing this exception
          setSelectedDateBoolArr(result);
          setExcpDatesBoolArr(copyExcpDatesBoolArr);
        }
      });
      return;
    }
    // If they are not same then either adding new date or editing existing date in exception list
    let check = false;
    copyExcpDatesBoolArr?.forEach((obj) => {
      if (obj.date === currentDate) {
        obj.slots = result;
        check = true;
      }
    });
    if (!check) {
      copyExcpDatesBoolArr.push({ date: currentDate, slots: result });
    }
    let slotId = calculateNoSlots(hours, minutes, merd);
    if (slotId + numSlots > 48) {
      // If Slots are exceeding current limit then the remaining will get added to next day
      console.log("Why its reaching here?");
      console.log(slotId + numSlots - 48);
      let nextDay = moment(currentDate, "DD/MM/YYYY")
        .add(1, "days")
        .format("DD/MM/YYYY");
      let nextDayCheck = false;
      let nextDayArray = [];
      copyExcpDatesBoolArr?.forEach((obj) => {
        if (obj.date === nextDay) {
          nextDayCheck = true;
          nextDayArray = concatSlots(
            obj.slots,
            "12",
            "00",
            "AM",
            slotId + numSlots - 48
          );
          obj.slots = nextDayArray;
        }
      });
      if (!nextDayCheck) {
        nextDayArray = concatSlots(
          boolGnrcSchd[
            moment(nextDay, "DD/MM/YYYY").format("ddd").toLowerCase()
          ],
          "12",
          "00",
          "AM",
          slotId + numSlots - 48
        );
        copyExcpDatesBoolArr.push({
          date: nextDay,
          slots: nextDayArray,
        });
        // Applying Same conditional check as above
        if (
          checkArrayEquality(
            nextDayArray,
            boolGnrcSchd[
              moment(nextDay, "DD/MM/YYYY").format("ddd").toLowerCase()
            ]
          )
        ) {
          copyExcpDatesBoolArr?.forEach((item, index) => {
            if (item.date === nextDay) {
              copyExcpDatesBoolArr.splice(index, 1); // Removing this exception
            }
          });
          setSelectedDateBoolArr(result);
          setExcpDatesBoolArr(copyExcpDatesBoolArr);
          return;
        }
        // nextDayArray = [
        //   ...boolGnrcSchd[
        //     moment(nextDay, "DD/MM/YYYY").format("ddd").toLowerCase()
        //   ],
        // ];
      }
      // let nextDaySlots = concatSlots(
      //   nextDayArray,
      //   "12",
      //   "00",
      //   "AM",
      //   slotId + numSlots - 48
      // );
      // copyExcpDatesBoolArr.push({ date: nextDay, slots: nextDaySlots });
    }
    console.log("copyExcpDatesBoolArr: ", copyExcpDatesBoolArr);
    setSelectedDateBoolArr(result);
    // setSelectedDateSlotsArr(convrtBoolTo12HTime(result));
    setExcpDatesBoolArr(copyExcpDatesBoolArr);
  };
  // -------------------------------------

  /*  
    - Editing Slots in Edit Availability
      editCustomSlot(currentlySelectedDate, fromTime, toTime, SelectedHours, SelectedMinutes, SelectedMeridiem, SelectedSlots)
    - It takes selected date in calender, startSlotId, endSlotId, 12-H time format, no of slots and modifies boolean array of that exception date
  */
  const editCustomSlot = (
    m_selectedDate,
    start,
    end,
    hours,
    minutes,
    merd,
    numSlots
  ) => {
    let copySelectedDateBoolArr = [...selectedDateBoolArr];
    let copyExcpDatesBoolArr = [...excpDatesBoolArr];
    const currentDate = moment(m_selectedDate).format("DD/MM/YYYY");
    for (let a = start; a <= end; a++) {
      // Removing slots from start to end
      copySelectedDateBoolArr[a] = false;
    }
    let result = concatSlots(
      // Adding new slots according to entered value
      copySelectedDateBoolArr,
      hours,
      minutes,
      merd,
      numSlots
    );
    if (
      checkArrayEquality(
        result,
        boolGnrcSchd[moment(m_selectedDate).format("ddd").toLowerCase()]
      )
    ) {
      copyExcpDatesBoolArr?.forEach((item, index) => {
        if (item.date === currentDate) {
          copyExcpDatesBoolArr.splice(index, 1); // Removing this exception
          setSelectedDateBoolArr(result);
          setExcpDatesBoolArr(copyExcpDatesBoolArr);
        }
      });
      return;
    }
    let check = false;
    copyExcpDatesBoolArr?.forEach((obj) => {
      if (obj.date === currentDate) {
        obj.slots = result;
        check = true;
      }
    });
    if (!check) {
      copyExcpDatesBoolArr.push({
        date: currentDate,
        slots: result,
      });
    }
    let slotId = calculateNoSlots(hours, minutes, merd);
    if (slotId + numSlots > 48) {
      // If Slots are exceeding current limit then the remaining will get added to next day
      console.log("Why its reaching here?");
      console.log(slotId + numSlots - 48);
      let nextDay = moment(currentDate, "DD/MM/YYYY")
        .add(1, "days")
        .format("DD/MM/YYYY");
      let nextDayCheck = false;
      let nextDayArray = [];
      copyExcpDatesBoolArr?.forEach((obj) => {
        if (obj.date === nextDay) {
          nextDayCheck = true;
          nextDayArray = concatSlots(
            obj.slots,
            "12",
            "00",
            "AM",
            slotId + numSlots - 48
          );
          obj.slots = nextDayArray;
        }
      });
      if (!nextDayCheck) {
        nextDayArray = concatSlots(
          boolGnrcSchd[
            moment(nextDay, "DD/MM/YYYY").format("ddd").toLowerCase()
          ],
          "12",
          "00",
          "AM",
          slotId + numSlots - 48
        );
        copyExcpDatesBoolArr.push({
          date: nextDay,
          slots: nextDayArray,
        });
        // Applying Same conditional check
        if (
          checkArrayEquality(
            nextDayArray,
            boolGnrcSchd[
              moment(nextDay, "DD/MM/YYYY").format("ddd").toLowerCase()
            ]
          )
        ) {
          copyExcpDatesBoolArr?.forEach((item, index) => {
            if (item.date === nextDay) {
              copyExcpDatesBoolArr.splice(index, 1); // Removing this exception
            }
          });
          setSelectedDateBoolArr(result);
          setExcpDatesBoolArr(copyExcpDatesBoolArr);
          return;
        }
      }
    }
    setSelectedDateBoolArr(result);
    // setSelectedDateSlotsArr(convrtBoolTo12HTime(result));
    setExcpDatesBoolArr(copyExcpDatesBoolArr);
  };
  // -------------------------------------

  /*  
    - Deleting Slots in Edit Availability
      syntax: deleteCustomSlot(selectedDate, startSlotId, endSlotId) 
    - It'll takes selected date in calender, startSlotId and endSlotId and deletes them from custom schedule
  */
  const deleteCustomSlot = (m_selectedDate, start, end) => {
    const currentDate = moment(m_selectedDate).format("DD/MM/YYYY");
    // let givenDayBol = [];
    let copySelectedDateBoolArr = [...selectedDateBoolArr];
    let copyExcpDatesBoolArr = [...excpDatesBoolArr];
    for (let a = start; a <= end; a++) {
      copySelectedDateBoolArr[a] = false;
    }
    if (
      checkArrayEquality(
        copySelectedDateBoolArr,
        boolGnrcSchd[moment(m_selectedDate).format("ddd").toLowerCase()]
      )
    ) {
      copyExcpDatesBoolArr?.forEach((item, index) => {
        if (item.date === currentDate) {
          copyExcpDatesBoolArr.splice(index, 1); // Removing this exception
        }
      });
      setSelectedDateBoolArr(copySelectedDateBoolArr);
      setExcpDatesBoolArr(copyExcpDatesBoolArr);
      return;
    }
    let check = false;
    copyExcpDatesBoolArr?.forEach((obj) => {
      if (obj.date === currentDate) {
        obj.slots = copySelectedDateBoolArr;
        check = true;
      }
    });
    if (!check) {
      copyExcpDatesBoolArr.push({
        date: currentDate,
        slots: copySelectedDateBoolArr,
      });
    }
    setSelectedDateBoolArr(copySelectedDateBoolArr);
    // setSelectedDateSlotsArr(convrtBoolTo12HTime(copySelectedDateBoolArr));
    setExcpDatesBoolArr(copyExcpDatesBoolArr);
  };
  // --------------------------------------

  /*
    - Add a date as an Exception
      excpDateForGnrcSchedule(selectedDate) 
    - It'll take currently selected date (the day of that date for which generic schedule was already specified), remove all the slots that were previously specified and adds this date to exception list with false * 48 in boolean list which automatically updates empty slot array in 12-H time format array
    - e.g. {date: 31-09-2022, slots: [false * 48]}
  */
  const excpDateForGnrcSchedule = (m_selectedDate) => {
    const currentDate = moment(m_selectedDate).format("DD/MM/YYYY");
    let copySelectedDateBoolArr = [...selectedDateBoolArr];
    let copyExcpDatesBoolArr = [...excpDatesBoolArr];
    copyExcpDatesBoolArr?.forEach((obj) => {
      if (obj.date === currentDate) {
        copySelectedDateBoolArr = obj.slots;
      }
    });
    for (let i = 0; i < 48; i++) {
      copySelectedDateBoolArr[i] = false;
    }
    let check = false;
    copyExcpDatesBoolArr?.forEach((obj) => {
      if (obj.date === currentDate) {
        obj.slots = copySelectedDateBoolArr;
        check = true;
      }
    });
    if (!check) {
      copyExcpDatesBoolArr.push({
        date: currentDate,
        slots: copySelectedDateBoolArr,
      });
    }
    setSelectedDateBoolArr(copySelectedDateBoolArr);
    setSelectedDateSlotsArr(convrtBoolTo12HTime(copySelectedDateBoolArr));
    setExcpDatesBoolArr(copyExcpDatesBoolArr);
  };
  // ------------------------------------

  /* 
    - Date Color of Calender
      - Green color for the dates which has only generic schedule.
      - Yellow color for the dates which have modified schedule from generic but is not holiday.
      - Red color for the dates which were part of generic schedule but later declared as holiday by interviewer.
      - No color for dates for which no schedule(generic/custom) was specified.
  */
  const [green, setGreen] = useState([]);
  const [yellow, setYellow] = useState([]);
  const [red, setRed] = useState([]);

  // Creating Date Array starting from today Date till the end of current month
  function dateRange(startDate) {
    const dateArray = [];
    let currentDate = new Date(startDate);
    while (
      currentDate <=
      new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1)
    ) {
      dateArray.push(new Date(currentDate));
      currentDate.setUTCDate(currentDate.getUTCDate() + 1);
    }

    return dateArray;
  }

  const handleDateChange = () => {
    let nowDate = new Date();
    if (calenderDate.getMonth() !== new Date().getMonth()) {
      console.log("true");
      nowDate = new Date(
        calenderDate.getFullYear(),
        calenderDate.getMonth(),
        1
      );
    } else {
      console.log("false");
      nowDate = new Date();
    }
    let dates = dateRange(nowDate);
    // Setting green array
    let newGreen = [];
    dates.forEach((item) => {
      // console.log("Array: ", slotwiseGenericSchd[moment(item).format("ddd").toLowerCase()]);
      if (
        slotwiseGenericSchd[moment(item).format("ddd").toLowerCase()].length !==
        0
      ) {
        newGreen.push(item.getDate());
      }
    });
    setGreen(newGreen);
    // Setting yellow and red array
    let newYellow = [];
    let newRed = [];
    excpDatesSlotsArr?.forEach((item) => {
      if (parseInt(item.date.slice(3, 5)) === nowDate.getMonth() + 1) {
        console.log("true");
        if (item.slots.length !== 0) {
          // console.log("non empty");
          newYellow.push(parseInt(item.date.slice(0, 2)));
        } else {
          // console.log("empty");
          newRed.push(parseInt(item.date.slice(0, 2)));
        }
      }
      console.log(parseInt(item.date.slice(3, 5)) === nowDate.getMonth() + 1);
    });
    setYellow(newYellow);
    setRed(newRed);
    console.log(
      "nowDate: ",
      nowDate,
      " green: ",
      green,
      " yellow: ",
      yellow,
      " red: ",
      red
    );
  };

  useEffect(() => {
    handleDateChange();
  }, [calenderDate, slotwiseGenericSchd, excpDatesSlotsArr]);
  // useEffect(() => {
  //   console.log("green: ", green);
  // }, [green]);
  // useEffect(() => {
  //   console.log("red: ", red);
  // }, [red]);
  // useEffect(() => {
  //   console.log("yellow: ", yellow);
  // }, [yellow]);
  // --------------------------------

  // Add Time Modal in Edit Availability in Custom Schedule
  const [openAddTimePopupInCustomSchd, setOpenAddTimePopupInCustomSchd] =
    useState(false);
  const handleAddTimePopupInCustomSchdOpen = () =>
    setOpenAddTimePopupInCustomSchd(true);
  const handleAddTimePopupInCustomSchdClose = () => {
    setOpenAddTimePopupInCustomSchd(false);
    setIsItEditing(false);
    setTime({
      hrs: "12",
      min: "00",
      merd: "AM",
    });
    setSlots(0);
  };
  const [oldTimeWhileEditingCustomSlot, setOldTimeWhileEditingCustomSlot] =
    useState({
      array: {},
      hrs: "12",
      min: "00",
      merd: "AM",
      start: 0,
      end: 0,
      index: 0,
    });

  /* 
    - Displaying slots on Popup in following format:
      (a) Selected Slots are
          Current Day: 11:00 PM - 11:59 PM
          Next Day: 12:00 AM - 01:00 AM
      (b) Selected Slots are
          11:00 PM - 11:30 PM
  */
  const getTimeSlots = (begin, number) => {
    let corr = moment(begin, "hh:mm a").format("hh:mm A");
    let end = moment(corr, "hh:mm A")
      .add(30 * number, "minutes")
      .format("hh:mm A");
    if (end.includes("12:00 AM")) {
      return (
        <>
          <p>{corr} - 11:59 PM</p>
        </>
      );
    } else if (corr.includes("PM") && end.includes("AM")) {
      return (
        <>
          <p>Current Day: {corr} - 11:59 PM</p>
          <p>Next Day: 12:00 AM - {end}</p>
        </>
      );
    } else {
      return (
        <p>
          {corr} - {end}
        </p>
      );
    }
  };
  // --------------------------
  return (
    <div className="m-5 p-2 rounded border-2 border-yellow-700">
      <div className="relative element">
        {slotwiseGenericSchd.mon.length !== 0 ||
        slotwiseGenericSchd.tue.length !== 0 ||
        slotwiseGenericSchd.wed.length !== 0 ||
        slotwiseGenericSchd.thu.length !== 0 ||
        slotwiseGenericSchd.fri.length !== 0 ||
        slotwiseGenericSchd.sat.length !== 0 ||
        slotwiseGenericSchd.sun.length !== 0 ? (
          <div className="absolute right-0">
            <Button
              variant="contained"
              color="error"
              onClick={handleClearGenericSchedulePopupOpen}
            >
              <i className="fa-solid fa-trash-can mr-2"></i> Clear All
            </Button>
            <Dialog
              open={openClearGenericSchedulePopup}
              onClose={handleClearGenericSchedulePopupClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"Are you sure about removing all the entries?"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  This will remove all the entries you have added and clear it
                  to blank.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={(e) => {
                    setSlotwiseGenericSchd({
                      mon: [],
                      tue: [],
                      wed: [],
                      thu: [],
                      fri: [],
                      sat: [],
                      sun: [],
                    });
                    initGnrcSchdBool();
                    handleClearGenericSchedulePopupClose();
                  }}
                >
                  YES
                </Button>
                <Button onClick={handleClearGenericSchedulePopupClose}>
                  NO
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        ) : null}
        <label htmlFor="time">Add Time Preference</label>
        <div className="flex justify-around mt-4 my-2"></div>
        <div className="grid grid-cols-4 gap-2">
          {/* Days */}
          {Object.keys(slotwiseGenericSchd).map((item) => (
            <div>
              <Typography
                variant="h6"
                component="h6"
                style={{
                  margin: "10px",
                  fontFamily: "'Ubuntu', sans-serif",
                  textAlign: "center",
                }}
              >
                {item === "mon"
                  ? "Monday"
                  : item === "tue"
                  ? "Tuesday"
                  : item === "wed"
                  ? "Wednesday"
                  : item === "thu"
                  ? "Thusday"
                  : item === "fri"
                  ? "Friday"
                  : item === "sat"
                  ? "Saturday"
                  : item === "sun"
                  ? "Sunday"
                  : null}
              </Typography>
              <div className="text-center">
                {slotwiseGenericSchd[item].length !== 0 ? (
                  slotwiseGenericSchd[item].map((arr) => (
                    <div
                      className="relative flex justify-between text-md rounded-full border bg-green-500 p-2 mb-2 mx-auto text-white"
                      style={{ width: "220px" }}
                    >
                      <p className="mx-auto">
                        {arr.final[0]} - {arr.final[1]}
                      </p>
                      <div
                        className="mx-1 cursor-pointer text-black hover:text-blue-600"
                        onClick={() => {
                          setIsItEditing(true);
                          handleOpenGenericSchedulePopup();
                          setCheckedDaysGenericSchedule({
                            ...checkedDaysGenericSchedule,
                            [item]: true,
                          });
                          disabledDaysWhileEditing(arr.init[0], arr.init[1]);
                          setTime({
                            hrs: arr.final[0].slice(0, 2),
                            min: arr.final[0].slice(3, 5),
                            merd: arr.final[0].slice(6, 8),
                          });
                          setSlots(arr.init[1] - arr.init[0] + 1);
                          setOldTimeWhileEditingASlot({
                            hrs: arr.final[0].slice(0, 2),
                            min: arr.final[0].slice(3, 5),
                            merd: arr.final[0].slice(6, 8),
                            start: arr.init[0],
                            end: arr.init[1],
                          });
                        }}
                      >
                        <i className="fa-solid fa-pen-to-square"></i>
                      </div>
                      <div
                        className="mx-1 cursor-pointer text-black hover:text-blue-600"
                        onClick={() => {
                          deleteSlots(item, arr.init[0], arr.init[1]);
                        }}
                      >
                        <i className="fa-solid fa-trash-can"></i>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No Specific Preference</p>
                )}
              </div>
            </div>
          ))}
        </div>
        <Modal
          open={openGenericSchedulePopup}
          // onClose={handleCloseGenericSchedulePopup}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 600,
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              p: 4,
            }}
          >
            <div
              className="absolute top-2 right-2"
              onClick={() => {
                handleCloseGenericSchedulePopup();
              }}
            >
              <IconButton aria-label="delete" size="small">
                <CancelIcon fontSize="medium" />
              </IconButton>
            </div>
            <div className="grid grid-cols-3">
              <div className="col-span-1">
                {["mon", "tue", "wed", "thu", "fri", "sat", "sun"].map(
                  (item) => (
                    <div>
                      <input
                        type="checkbox"
                        id={item}
                        name={item}
                        value={item}
                        disabled={
                          disableDaysWhileEditingGenericSlot[item]
                            ? true
                            : false
                        }
                        checked={checkedDaysGenericSchedule[item]}
                        onChange={() => {
                          setCheckedDaysGenericSchedule({
                            ...checkedDaysGenericSchedule,
                            [item]: !checkedDaysGenericSchedule[item],
                          });
                        }}
                      />
                      <label
                        htmlFor={item}
                        style={
                          disableDaysWhileEditingGenericSlot[item]
                            ? { color: "#e5e7eb" }
                            : { color: "#000" }
                        }
                      >
                        {item === "mon"
                          ? "Monday"
                          : item === "tue"
                          ? "Tuesday"
                          : item === "wed"
                          ? "Wednesday"
                          : item === "thu"
                          ? "Thursday"
                          : item === "fri"
                          ? "Friday"
                          : item === "sat"
                          ? "Saturday"
                          : item === "sun"
                          ? "Sunday"
                          : null}
                      </label>
                    </div>
                  )
                )}
                <div>
                  <input
                    type="checkbox"
                    id="all"
                    name="all"
                    value="all"
                    disabled={isItEditing ? true : false}
                    checked={allDaysCheckedGenericSchedule}
                    onChange={() => {
                      setCheckedDaysGenericSchedule({
                        ...checkedDaysGenericSchedule,
                        mon: !allDaysCheckedGenericSchedule,
                        tue: !allDaysCheckedGenericSchedule,
                        wed: !allDaysCheckedGenericSchedule,
                        thu: !allDaysCheckedGenericSchedule,
                        fri: !allDaysCheckedGenericSchedule,
                        sat: !allDaysCheckedGenericSchedule,
                        sun: !allDaysCheckedGenericSchedule,
                      });
                      setAllDaysCheckedGenericSchedule(
                        !allDaysCheckedGenericSchedule
                      );
                    }}
                  />
                  <label
                    htmlFor="all"
                    style={{
                      color: isItEditing ? "#e5e7eb" : "#000",
                    }}
                  >
                    {allDaysCheckedGenericSchedule
                      ? "Unselect All"
                      : "Select All"}
                  </label>
                </div>
              </div>
              <div className="col-span-2">
                <div className="my-2">
                  <p className="mb-2">Set Time</p>
                  <div className="flex rounded border w-24" id="time-picker">
                    <select
                      className="text-right"
                      name="hours"
                      id="hours"
                      value={time.hrs}
                      onChange={(e) => {
                        setTime({ ...time, hrs: e.target.value });
                      }}
                    >
                      <option value="12">12</option>
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                    </select>
                    <p className="mx-1">:</p>
                    <select
                      className="text-right"
                      name="min"
                      id="min"
                      value={time.min}
                      onChange={(e) => {
                        setTime({ ...time, min: e.target.value });
                      }}
                    >
                      <option value="00">00</option>
                      <option value="30">30</option>
                    </select>
                    <select
                      className="text-right"
                      name="merd"
                      id="merd"
                      value={time.merd}
                      onChange={(e) => {
                        setTime({ ...time, merd: e.target.value });
                      }}
                    >
                      <option value="AM">AM</option>
                      <option value="PM">PM</option>
                    </select>
                  </div>
                </div>
                <div className="my-2">
                  <p className="mb-2">No. of Mock Interviews Slots</p>
                  <InputLabel id="slots">Slots</InputLabel>
                  <Select
                    labelId="slots"
                    id="slots-select"
                    value={slots}
                    label="Slots"
                    sx={{ width: 0.2 }}
                    onChange={handleSlotsChange}
                  >
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                  </Select>
                </div>
                {slots !== 0 &&
                (checkedDaysGenericSchedule.mon === true ||
                  checkedDaysGenericSchedule.tue === true ||
                  checkedDaysGenericSchedule.wed === true ||
                  checkedDaysGenericSchedule.thu === true ||
                  checkedDaysGenericSchedule.fri === true ||
                  checkedDaysGenericSchedule.sat === true ||
                  checkedDaysGenericSchedule.sun === true ||
                  allDaysCheckedGenericSchedule === true) ? (
                  <div className="my-2">
                    <p>Selected Slots are</p>
                    {getTimeSlots(
                      time.hrs + ":" + time.min + " " + time.merd,
                      slots
                    )}
                  </div>
                ) : null}
                <Button
                  variant="contained"
                  onClick={() => {
                    if (isItEditing !== true) {
                      addNewGenericTimeSlots(
                        time.hrs,
                        time.min,
                        time.merd,
                        slots,
                        checkedDaysGenericSchedule
                      );
                    } else {
                      editGenericTimeSlots(
                        checkedDaysGenericSchedule,
                        oldTimeWhileEditingASlot.start,
                        oldTimeWhileEditingASlot.end,
                        time.hrs,
                        time.min,
                        time.merd,
                        slots
                      );
                      handleCloseGenericSchedulePopup();
                      return;
                    }
                    handleCloseGenericSchedulePopup();
                  }}
                >
                  Save
                </Button>
              </div>
            </div>
          </Box>
        </Modal>
        {slotwiseGenericSchd.mon.length !== 0 ||
        slotwiseGenericSchd.tue.length !== 0 ||
        slotwiseGenericSchd.wed.length !== 0 ||
        slotwiseGenericSchd.thu.length !== 0 ||
        slotwiseGenericSchd.fri.length !== 0 ||
        slotwiseGenericSchd.sat.length !== 0 ||
        slotwiseGenericSchd.sun.length !== 0 ? (
          <div className="flex gap-2">
            <Button
              variant="contained"
              onClick={handleOpenGenericSchedulePopup}
            >
              + Add More Time
            </Button>
            <div>
              <Button
                variant="contained"
                color="error"
                onClick={() => {
                  handleIsCustomEditPopupOpen();
                }}
              >
                Edit Availability
              </Button>
              <Modal
                open={isCustomEditPopupOpen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    borderLeft: "12px solid #9375ff",
                    borderRadius: 2,
                    p: 2,
                  }}
                >
                  <div
                    className="absolute top-2 right-2"
                    onClick={() => {
                      handleIsCustomEditPopupClose();
                    }}
                  >
                    <IconButton aria-label="delete" size="small">
                      <CancelIcon fontSize="medium" />
                    </IconButton>
                  </div>
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: "bold",
                      textAlign: "center",
                      color: "#6844c9",
                    }}
                  >
                    Edit Availability
                  </Typography>
                  {/* <div className="grid grid-flow-col auto-cols-max"> */}
                  <div className="grid grid-cols-2">
                    <div className="flex items-center justify-center">
                      <Calendar
                        minDate={new Date().setDate(new Date().getDate())}
                        value={calenderDate}
                        onMonthChange={(date) =>
                          setCalenderDate(new Date(date))
                        }
                        onChange={(e) => {
                          setCalenderDate(new Date(e));
                        }}
                        mapDays={({
                          date,
                          today,
                          selectedDate,
                          isSameDate,
                        }) => {
                          let props = {};
                          props.style = {
                            backgroundColor: "#fff",
                            color: "#000",
                            fontWeight: 700,
                          };
                          if (isSameDate(date, today)) {
                            const currentSelectedDate = new Date();
                            green.map((item) => {
                              if (currentSelectedDate.getDate() === item) {
                                // console.log("green");
                                props.style = {
                                  backgroundColor: "rgb(72 187 120)",
                                  color: "#fff",
                                  fontWeight: 500,
                                };
                              }
                            });
                            yellow.map((item) => {
                              if (currentSelectedDate.getDate() === item) {
                                // console.log("yellow");
                                props.style = {
                                  backgroundColor: "rgb(236 201 75)",
                                  color: "#fff",
                                  fontWeight: 500,
                                };
                              }
                            });
                            red.map((item) => {
                              if (currentSelectedDate.getDate() === item) {
                                // console.log("red");
                                props.style = {
                                  backgroundColor: "rgb(245 101 101)",
                                  color: "#fff",
                                  fontWeight: 500,
                                };
                              }
                            });
                            return props;
                          }

                          if (isSameDate(date, selectedDate)) {
                            const currentSelectedDate = new Date(date);
                            props.style = {
                              backgroundColor: "#fff",
                              color: "#000",
                              border: "1px solid #000",
                            };
                            green.map((item) => {
                              if (currentSelectedDate.getDate() === item) {
                                props.style = {
                                  backgroundColor: "rgb(72 187 120)",
                                  color: "#000",
                                  border: "1px solid #000",
                                };
                              }
                            });
                            yellow.map((item) => {
                              if (currentSelectedDate.getDate() === item) {
                                props.style = {
                                  backgroundColor: "rgb(236 201 75)",
                                  color: "#000",
                                  border: "1px solid #000",
                                };
                              }
                            });
                            red.map((item) => {
                              if (currentSelectedDate.getDate() === item) {
                                props.style = {
                                  backgroundColor: "rgb(245 101 101)",
                                  color: "#000",
                                  border: "1px solid #000",
                                };
                              }
                            });
                            return props;
                          }

                          // if ([4, 5, 6, 7].includes(date.day)) {
                          //   return { className: "text-red-500" };
                          // }
                          // if ([10, 11, 12, 13].includes(date.day)) {
                          //   return { className: "text-yellow-500" };
                          // }
                          // if ([15, 16, 17].includes(date.day)) {
                          //   return { className: "text-green-500" };
                          // }
                          if (red.includes(date.day)) {
                            return { className: "bg-red-500" };
                          }
                          if (yellow.includes(date.day)) {
                            return { className: "bg-yellow-500" };
                          }
                          if (green.includes(date.day)) {
                            return { className: "bg-green-500" };
                          }
                        }}
                      />
                    </div>
                    <div className="h-full">
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: "bold",
                          mt: 2,
                          mb: 2,
                        }}
                      >
                        Availability on {moment(calenderDate).format("Do MMMM")}
                      </Typography>
                      {selectedDateSlotsArr.length !== 0 ? (
                        <div
                          // className="p-2 grid grid-cols-2 gap-1"
                          className="relative p-2 mb-2 rounded bg-gray-200 slots-gradiant"
                          // style={{ width: "520px" }}
                        >
                          <div
                            className="absolute top-1 right-0"
                            onClick={() => {
                              excpDateForGnrcSchedule(calenderDate);
                            }}
                          >
                            <IconButton aria-label="delete" size="small">
                              <CancelIcon fontSize="small" color="error" />
                            </IconButton>
                          </div>
                          {selectedDateSlotsArr !== [] ? (
                            selectedDateSlotsArr.map((item, index) => {
                              return (
                                <div
                                  className="flex justify-between text-md rounded-full border bg-green-500 p-2 mb-1 mx-auto text-white"
                                  style={{ width: "220px" }}
                                >
                                  <p className="mx-auto">
                                    {item.final[0]} - {item.final[1]}
                                  </p>
                                  <div
                                    className="mx-1 cursor-pointer text-black hover:text-blue-600"
                                    onClick={() => {
                                      setIsItEditing(true);
                                      handleAddTimePopupInCustomSchdOpen();
                                      setTime({
                                        hrs: item.final[0].slice(0, 2),
                                        min: item.final[0].slice(3, 5),
                                        merd: item.final[0].slice(6, 8),
                                      });
                                      setSlots(item.init[1] - item.init[0] + 1);
                                      setOldTimeWhileEditingCustomSlot({
                                        array: item,
                                        hrs: item.final[0].slice(0, 2),
                                        min: item.final[0].slice(3, 5),
                                        merd: item.final[0].slice(6, 8),
                                        start: item.init[0],
                                        end: item.init[1],
                                        index: index,
                                      });
                                    }}
                                  >
                                    <i className="fa-solid fa-pen-to-square"></i>
                                  </div>
                                  <div
                                    className="mx-1 cursor-pointer text-black hover:text-blue-600"
                                    onClick={() => {
                                      deleteCustomSlot(
                                        calenderDate,
                                        item.init[0],
                                        item.init[1]
                                      );
                                    }}
                                  >
                                    <i className="fa-solid fa-trash-can"></i>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <p>No Slots Specified</p>
                          )}
                        </div>
                      ) : null}
                      <div className="">
                        {selectedDateSlotsArr !== 0 ? (
                          <div className="flex">
                            <div className="my-1">
                              <Button
                                variant="contained"
                                onClick={() => {
                                  resetToGenrcSchd(calenderDate);
                                }}
                              >
                                Reset to Default
                              </Button>
                            </div>
                            <div className="my-1">
                              <Button
                                variant="contained"
                                onClick={handleAddTimePopupInCustomSchdOpen}
                              >
                                + Add More Time
                              </Button>
                            </div>
                          </div>
                        ) : (
                          <Button
                            variant="contained"
                            onClick={handleAddTimePopupInCustomSchdOpen}
                          >
                            Add Time
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center">
                    <Button variant="contained">Save</Button>
                  </div>
                </Box>
              </Modal>
              <Modal
                open={openAddTimePopupInCustomSchd}
                onClose={handleAddTimePopupInCustomSchdClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                  }}
                >
                  <div className="">
                    <div className="">
                      <p>Date: {moment(calenderDate).format("DD/MM/YYYY")}</p>
                      <div className="my-2">
                        <p className="mb-2">Set Time</p>
                        <div
                          className="flex rounded border w-24"
                          id="time-picker"
                        >
                          <select
                            className="text-right"
                            name="hours"
                            id="hours"
                            value={time.hrs}
                            onChange={(e) => {
                              setTime({
                                ...time,
                                hrs: e.target.value,
                              });
                            }}
                          >
                            <option value="12">12</option>
                            <option value="01">01</option>
                            <option value="02">02</option>
                            <option value="03">03</option>
                            <option value="04">04</option>
                            <option value="05">05</option>
                            <option value="06">06</option>
                            <option value="07">07</option>
                            <option value="08">08</option>
                            <option value="09">09</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                          </select>
                          <p className="mx-1">:</p>
                          <select
                            className="text-right"
                            name="min"
                            id="min"
                            value={time.min}
                            onChange={(e) => {
                              setTime({
                                ...time,
                                min: e.target.value,
                              });
                            }}
                          >
                            <option value="00">00</option>
                            <option value="30">30</option>
                          </select>
                          <select
                            className="text-right"
                            name="merd"
                            id="merd"
                            value={time.merd}
                            onChange={(e) => {
                              setTime({
                                ...time,
                                merd: e.target.value,
                              });
                            }}
                          >
                            <option value="AM">AM</option>
                            <option value="PM">PM</option>
                          </select>
                        </div>
                      </div>
                      <div className="my-2">
                        <p className="mb-2">No. of Mock Interviews Slots</p>
                        <InputLabel id="slots">Slots</InputLabel>
                        <Select
                          labelId="slots"
                          id="slots-select"
                          value={slots}
                          label="Slots"
                          sx={{ width: 0.2 }}
                          onChange={handleSlotsChange}
                        >
                          <MenuItem value={0}>0</MenuItem>
                          <MenuItem value={1}>1</MenuItem>
                          <MenuItem value={2}>2</MenuItem>
                          <MenuItem value={3}>3</MenuItem>
                          <MenuItem value={4}>4</MenuItem>
                          <MenuItem value={5}>5</MenuItem>
                          <MenuItem value={6}>6</MenuItem>
                          <MenuItem value={7}>7</MenuItem>
                          <MenuItem value={8}>8</MenuItem>
                          <MenuItem value={9}>9</MenuItem>
                          <MenuItem value={10}>10</MenuItem>
                        </Select>
                      </div>
                      {slots !== 0 ? (
                        <div className="my-2">
                          <p>Selected Slots are</p>
                          {getTimeSlots(
                            time.hrs + ":" + time.min + " " + time.merd,
                            slots
                          )}
                        </div>
                      ) : null}
                      <Button
                        variant="contained"
                        onClick={() => {
                          if (isItEditing !== true) {
                            addNewCustomSlot(
                              calenderDate,
                              time.hrs,
                              time.min,
                              time.merd,
                              slots
                            );
                          } else {
                            editCustomSlot(
                              calenderDate,
                              oldTimeWhileEditingCustomSlot.start,
                              oldTimeWhileEditingCustomSlot.end,
                              time.hrs,
                              time.min,
                              time.merd,
                              slots
                            );
                            handleAddTimePopupInCustomSchdClose();
                            return;
                          }
                          handleAddTimePopupInCustomSchdClose();
                        }}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                </Box>
              </Modal>
            </div>
          </div>
        ) : (
          <Button variant="contained" onClick={handleOpenGenericSchedulePopup}>
            Add Time
          </Button>
        )}
      </div>
    </div>
  );
};

export default TimePreference;
